import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, NgModule, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { GlobalModule } from '@app/_global/global.module';
import { Article } from '@app/texte/texte.model';
import { EventManagerService, IEventListener } from '@global/event-manager.service';
import { HTMLEditorModule } from '@app/components/html-editor';

import { uid } from '@helpers/utils';

@Component({
	selector: 'edition-article-dialog',
	template: `
		<form #form class="mb-2 h-full" #ajoutRubriqueDialog="ngForm" (ngSubmit)="submit()">

			<div
				class="w-full h-full"
			>
				<html-editor
					name="art_corps-{{article.art_id}}"
					id="art_corps-{{article.art_id}}"
					[(ngModel)]="article.art_corps"
					class="with-scrollable-angular-editor-wrapper-500"
				></html-editor>
			</div>

			<div class="text-center pt-4 border-gray-200">
				<!-- Bouton enregistrer -->
				<button
					type="button"
					pButton
					class="label-md-none"
					[label]="'common.validate_button_label' | translate"
					icon="pi pi-check"
					(click)="submit()"
				></button>

				<!-- Bouton annuler -->
				<button
					type="button"
					pButton
					class="p-confirm-dialog-reject ml-1"
					[label]="'common.cancel' | translate"
					icon="pi pi-times"
					(click)="cancel()"
				></button>
			</div>
		</form>
	`,
	providers: []
})
export class EditionArticleDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	article: Article

	@ViewChild('form') formElement: ElementRef<HTMLFormElement>;

	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
	) {
		this.article = config.data.article;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => {
			this.dialogRef.close();
		});
	}

	submit(){
		this.dialogRef.close(this.article);
	}

	cancel(){
		this.dialogRef.close();
	}

	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}
}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		HTMLEditorModule
	],
	exports: [EditionArticleDialogComponent],
	declarations: [EditionArticleDialogComponent]
})
export class EditionArticleDialogModule { }

